import { randomId } from '@shared/utils/randomId.js';
import IconV2 from '@/components/v2/IconV2.jsx';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2.jsx';
import Spinner from '@/components/Spinner.jsx';
import { HiMiniEllipsisHorizontal } from '@/components/react-icons/main';
import TableCell from './TableCell.jsx';

const TableRow = ({ data, columns, actions = [], actionMenuFitContent = false, hasActions = false, onChange, onAction, onRowClick, select }) => {
  const id = randomId();
  const isActionLoading = actions.some((action) => action.loading);

  return (
    <div className={`table-row ${onRowClick ? 'table-row-highlight' : ''}`} onClick={(event) => onRowClick?.(data, event)}>
      {columns
        .filter((c) => !!c?.width)
        .map((column, index) => (
          <TableCell key={index} column={column} value={data[column.key]} style={{ ...column.style, width: column.width }} onChange={(e) => onChange(column, data, e)} select={select} />
        ))}
      {hasActions && (
        <div className={'table-cell actions-cell'}>
          {actions?.length > 0 && (
            <>
              <IconV2 icon={isActionLoading ? Spinner : HiMiniEllipsisHorizontal} className={`light-medium actions-button ${isActionLoading ? 'loading' : ''} ${id}`} />
              {!isActionLoading && <FloatingSelectV2 className={actionMenuFitContent ? 'fit-content' : ''} triggers={[`.${id}`]} options={actions} onChange={(e) => onAction(data, e)} useSearch={false} smartWidth={actionMenuFitContent} virtualize={actionMenuFitContent ? false : undefined} />}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TableRow;
